module.exports = __webpack_public_path__ + "img/logoold.a5d6fa57.png";